import type { Dictionary } from "../i18n";

const dictionary: Dictionary = {
  "success.pendingTitle": "Votre commande est toujours en cours de confirmation",
  "success.pendingBody": "La confirmation du paiement prend plus de temps que prévu. Ne payez pas à nouveau. Vous pouvez vérifier à nouveau, revenir à votre commande ou contacter l’assistance avec le numéro de commande ci-dessous.",
  "success.cancelledTitle": "Cette commande a été annulée",
  "success.cancelledBody": "Si votre carte a été débitée ou bloquée, le montant vous est restitué. Vous n’avez rien à faire.",
  "success.checkAgain": "Vérifier à nouveau",

  "error.countryClosed": "Les nouvelles commandes et le paiement des commandes impayées ne sont plus disponibles dans ce pays. Les commandes payées et l’assistance continuent.",
  "error.providerCountryClosed": "Votre commande ne peut plus être réalisée par le prestataire attribué. Passez une nouvelle commande et nous vous attribuerons un nouveau prestataire.",
  "chrome.reviewTitle": "Vérifier et payer",
  "chrome.paidTitle": "Confirmation de la commande",
  "chrome.paymentTitle": "Paiement",
  "chrome.language": "Langue",
  "chrome.close": "Fermer",
  "chrome.logoAlt": "Tinkr",
  "common.loading": "Chargement",
  "common.error": "Une erreur s’est produite.",
  "common.retry": "Réessayer",
  "common.labelSeparator": " : ",
  "trust.badge": "Vendu par Tinkr · Fabriqué par un partenaire d’impression local agréé",
  "review.orderSummary": "Récapitulatif de la commande",
  "review.threeD": "3D",
  "review.specsQty": "Qté",
  "review.delivery.title": "Livraison",
  "review.shipping.title": "Coordonnées de livraison",
  "review.shipping.edit": "Modifier",
  "review.payment.title": "Mode de paiement",
  "review.payment.card": "Carte de crédit ou de débit",
  "review.payment.cardHint": "Visa, Mastercard et autres",
  "review.payment.usdc": "Stablecoin USDC",
  "review.payment.comingSoon": "Bientôt disponible",
  "review.price.title": "Prix",
  "review.price.itemSubtotal": "Sous-total des articles",
  "review.price.premium": "Production premium",
  "review.price.shipping": "Livraison",
  "review.price.shippingIncluded": "Incluse",
  "review.price.total": "Total de la commande",
  "review.price.taxNote": "Tinkr ne facture pas de taxe sur les transactions pour cette commande.",
  "review.price.updating": "Mise à jour du total…",
  "review.price.refreshError": "Nous n’avons pas pu actualiser votre total. Rechargez la page avant de payer.",
  "review.price.multicolor": "Multicolore",
  "review.price.multicolorCapNote": "Nous n'avons pas pu mesurer précisément cette figurine, le prix multicolore maximal s'applique donc.",
  "review.pricing.calculating": "Calcul de votre prix exact…",
  "review.pricing.calculatingBody": "Le prix de votre figurine multicolore est calculé à partir de sa propre impression. Cela prend généralement moins d'une minute.",
  "review.pricing.from": "À partir de",
  "review.pricing.stillWorking": "Toujours en cours. Merci de votre patience.",
  "review.pricing.timeout": "Nous n'avons pas pu terminer le calcul de votre prix. Veuillez réessayer.",
  "review.consent.prefix": "En cochant cette case, vous acceptez les",
  "review.consent.terms": "Conditions d’utilisation",
  "review.consent.and": "et la",
  "review.consent.privacy": "Politique de confidentialité",
  "review.cta.pay": "Payer",
  "review.cta.secure": "Paiement sécurisé",
  "coupon.toggle": "Vous avez un code promotionnel ?",
  "coupon.label": "Code promotionnel",
  "coupon.placeholder": "Saisissez le code",
  "coupon.apply": "Appliquer",
  "coupon.applying": "Application…",
  "coupon.remove": "Retirer",
  "coupon.removing": "Suppression…",
  "coupon.appliedLabel": "Code promotionnel",
  "coupon.error.notFound": "Nous n’avons pas trouvé ce code promotionnel",
  "coupon.error.expired": "Ce code promotionnel a expiré",
  "coupon.error.revoked": "Ce code promotionnel n’est plus valide",
  "coupon.error.notStarted": "Ce code promotionnel n’est pas encore actif",
  "coupon.error.notApplicable": "Ce code promotionnel ne peut pas être utilisé pour cette commande",
  "coupon.error.usageLimit": "Ce code promotionnel a atteint sa limite d’utilisation",
  "coupon.error.alreadyApplied": "Ce code promotionnel est déjà appliqué",
  "coupon.error.retry": "Veuillez patienter un instant, puis réessayer",
  "coupon.error.generic": "Ce code ne peut pas être utilisé",
  "redirect.title": "Redirection vers le paiement sécurisé…",
  "redirect.subtitle": "Vous allez être redirigé vers la page de paiement sécurisé de Stripe.",
  "redirect.badgeVerified": "Vérifié",
  "redirect.badgeEncrypted": "Chiffré",
  "redirect.badgeSsl": "Connexion SSL sécurisée",
  "success.title": "Paiement effectué !",
  "success.authorizedTitle": "Commande confirmée !",
  "success.orderNumber": "Numéro de commande",
  "success.paidTotal": "Montant payé",
  "success.authorizedTotal": "Blocage temporaire sur la carte",
  "success.nextTitle": "Étapes suivantes",
  "success.step1": "Votre partenaire d’impression est informé",
  "success.step2": "Il imprime et contrôle la qualité",
  "success.step3": "Votre commande vous est expédiée",
  "success.statusCompleted": "Terminé",
  "success.statusPending": "En cours",
  "success.statusUpcoming": "À venir",
  "success.track": "Suivre votre commande",
  "success.viewOrder": "Voir votre commande →",
  "success.back": "Retour à Tinkr",
  "success.returnToDoodles": "Retour à Tinkr Doodles",
  "success.returnToSite": "Retour à votre commande",
  "success.confirming": "Confirmation de votre commande…",
  "success.notConfirmed": "Nous n’avons pas encore pu confirmer votre commande. Veuillez réessayer dans quelques minutes.",
  "cancelled.title": "Vous avez quitté la page de paiement",
  "cancelled.body": "Votre commande est enregistrée. La mise à jour du statut du paiement peut prendre un instant.",
  "cancelled.orderRef": "Numéro de commande",
  "cancelled.tip": "Vérifiez votre connexion ou l’autorisation de votre banque, puis réessayez.",
  "cancelled.retry": "Réessayer",
  "cancelled.help": "Aide",
  "footer.terms": "Conditions d’utilisation",
  "footer.privacy": "Confidentialité",
  "footer.refund": "Remboursements et annulations",
  "footer.seller": "Informations sur le vendeur",
  "footer.tokushoho": "Avis relatif à la loi sur les transactions commerciales spécifiées",
  "footer.entity": "Tinkr App Ltd",
  "footer.companyNo": "Société n°",
  "legal.back": "Retour",
  "legal.updated": "Dernière mise à jour",
  "error.notFound": "Nous n’avons pas trouvé ce lien de paiement. Vérifiez le lien figurant dans votre e-mail.",
  "error.expired": "Ce lien de paiement a expiré.",
  "error.alreadyPaid": "Cette commande a déjà été payée.",
  "error.payFailed": "Nous n’avons pas pu lancer le paiement. Veuillez réessayer.",
  "error.couponNoLongerValid": "Le code promotionnel appliqué à cette commande n’est plus valide. Retirez-le, puis réessayez.",
  "error.couponLimitReached": "Ce code promotionnel a atteint sa limite d’utilisation pour le moment. Retirez-le pour continuer, ou réessayez plus tard.",
  "error.couponNotApplicable": "Ce code promotionnel ne s’applique pas au montant de cette commande. Retirez-le, puis réessayez.",
  "error.paymentConfirming": "Votre paiement est déjà en cours de confirmation. Patientez un instant, puis actualisez cette page.",
  "error.sessionConflict": "Le paiement a été modifié dans une autre fenêtre. Veuillez réessayer.",
  "error.recoveryHint": "Ouvrez le dernier e-mail concernant votre commande pour obtenir un nouveau lien de paiement, ou contactez l’assistance afin que nous réglions le problème.",
  "error.backToSite": "Retour au site"
};

export default dictionary;
